import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';

import sortSVG from 'features/generalReport/img/sort.svg';
import arrowSVG from 'features/generalReport/img/arrow-sort.svg';
import { sortFieldsForMobile } from 'features/generalReport/data';

import TableRow from './TableRow/TableRow';

import './TableProviders.scss';

const b = block('reports-table-providers-mobile');

const TableProviders = ({ handlers, values }) => {
  const locale = useSelector(state => state.locale.locale);

  const sortedAndReorderedData = useMemo(() => {
    let sortedData = [...values.statisticProvider.providers];

    if (values.state.sortBy.type) {
      sortedData.sort((a, b) => {
        let aValue = a[values.state.sortBy.type]?.current;
        let bValue = b[values.state.sortBy.type]?.current;

        if (values.state.sortBy.type !== 'provider') {
          aValue = parseFloat(aValue);
          bValue = parseFloat(bValue);
        }

        if (aValue < bValue) {
          return values.state.sortBy.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return values.state.sortBy.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortedData.map(obj => {
      const newObj = {};
      sortFieldsForMobile.forEach(key => {
        newObj[key] = obj[key];
      });

      return newObj;
    });
  }, [values]);

  const handleSortClick = () => {
    const newDirection = values.state.sortBy.direction === 'asc' ? 'desc' : 'asc';

    handlers.handleValueChange('sortBy', {
      ...values.state.sortBy,
      direction: newDirection,
    });
  };

  const rows = useMemo(
    () =>
      sortedAndReorderedData?.map((item, index) => (
        <TableRow key={index} headers={sortFieldsForMobile} item={item} withDiff={values.state.withDiff} />
      )),
    [sortedAndReorderedData, values.state.withDiff],
  );

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('header-title')}>{locale.byProvider}</div>
        <div className={b('header-controls')}>
          <SVG
            onClick={() =>
              handlers.handleValueChange('sortBy', { ...values.state.sortBy, isOpen: !values.state.sortBy.isOpen })
            }
            svgProps={{ svg: arrowSVG }}
            className={b('header-icon', { rotate: values.state.sortBy.isOpen })}
          />
          <SVG
            onClick={handleSortClick}
            svgProps={{ svg: sortSVG }}
            className={b('header-icon', {
              rotate: values.state.sortBy.direction === 'asc',
            })}
          />
          {values.state.sortBy.isOpen && (
            <div className={b('header-controls-popup')}>
              <div className={b('header-controls-popup-top')}>
                <div className={b('header-controls-popup-title')}>{locale.classification}</div>
                <SVG svgProps={{ svg: arrowSVG }} className={b('header-icon', { small: true })} />
              </div>
              <div className={b('header-controls-popup-items')}>
                <div
                  onClick={() =>
                    handlers.handleValueChange('sortBy', {
                      ...values.state.sortBy,
                      isOpen: false,
                      type: 'betCount',
                      direction: 'desc',
                    })
                  }
                  className={b('header-controls-popup-item', { active: values.state.sortBy.type === 'betCount' })}>
                  {locale.betCount}
                </div>
                <div
                  onClick={() =>
                    handlers.handleValueChange('sortBy', {
                      ...values.state.sortBy,
                      isOpen: false,
                      type: 'incomeAmount',
                      direction: 'desc',
                    })
                  }
                  className={b('header-controls-popup-item', { active: values.state.sortBy.type === 'incomeAmount' })}>
                  {locale.incomeAmount}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {!!values.statisticProvider.providers.length ? (
        <div className={b('rows')}>{rows}</div>
      ) : (
        <div className={b('no-results')}>{locale.noResultsFound}</div>
      )}
    </div>
  );
};

TableProviders.propTypes = {};

export default TableProviders;
